module.exports = __webpack_public_path__ + "img/5.66295ddd.png";